<template>
  <section>
    <div>
      <AddParceiro />
    </div>
  </section>
</template>

<script>
import AddParceiro from '@/components/AddParceiro.vue';
import { mapState } from 'vuex';

export default {
  name: 'AdicionarParceiro',
  components: {
    AddParceiro,
  },
  computed: {
    ...mapState(['usuario', 'login', 'alliances']),
  },
  watch: {
    login() {
      this.getAlliances();
    },
  },
};
</script>

<style></style>
